import R from 'ramda'

const SEND_DARK_REPLY_ACTION_TYPE = 'SEND_DARK_REPLY'
const SEND_DARK_REPLY_DISPLAY_TYPE = 'Send reply'
const SEND_DARK_REPLY_DISPLAY_ACTION_TYPE = 'SEND_REPLY'

const isSendDarkReplyWidgetAction = R.propEq(
  'type',
  SEND_DARK_REPLY_ACTION_TYPE
)

const convertSendDarkReplyWidgetActionToFormAction = R.applySpec({
  type: R.always(SEND_DARK_REPLY_DISPLAY_TYPE),
  action: R.always(SEND_DARK_REPLY_DISPLAY_ACTION_TYPE),
  message: R.prop('message'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  isPromotedTweet: R.T
})

export {
  isSendDarkReplyWidgetAction,
  convertSendDarkReplyWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-dark-reply.js